export const Newsletters = [{
    'id': '314837ec05',
    'name': 'Daily Newsletter',
    'description': 'Keep up to date with all of The Daily Princetonian’s coverage, delivered weekdays.',
    'url': 'http://eepurl.com/GveCn'
}];
